import './white-button.scss'
import Button from '@mui/material/Button'



interface iProps {label:string,fun:Function,children?:any,fullWidth?:boolean,disabled?:boolean}
export default function WhiteButton ({label,fun,children,fullWidth,disabled}:iProps) {

    return (
    //     <Button className="WhiteButtonContainer"
    //    fullWidth={fullWidth}
    
    //     onClick={()=>fun()}>
    //         <span className='text'>{label} </span>
    //         <span className="children">{children}</span>

    //     </Button>
    <button className="whiteButton"
    disabled={disabled}
       
    
         onClick={()=>fun()}>
             <span className='text'>{label} </span>
             <span className="children">{children}</span>

    </button>
    )
}